import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// service imports
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { WorkflowVendorMissingBillsService } from '../../../_services/workflow-vendor-missing-bills.service';

// Model imports
import { VendorMissingBillsHistoryResultDto } from '../../../_models/workflow-vendor-missing-bills/vendor-missing-bills-history-result-dto';
import { VendorMissingBillsHistoryParametersDto } from '../../../_models/workflow-vendor-missing-bills/vendor-missing-bills-history-parameter-dto';

@Component({
    selector: 'app-vendor-missing-bill-history',
    templateUrl: './vendor-missing-bill-history.component.html',
    styleUrls: ['./vendor-missing-bill-history.component.scss']
})
export class VendorMissingBillHistoryComponent implements OnInit {
    @ViewChild('vendorMissingBillHistoryPopup', { static: false }) vendorMissingBillHistoryPopup: DxPopupComponent;

    @Input() missingBillQueueId: number;
    @Input() communityId: number;

    @Output() onClose = new EventEmitter();

    visible = false;

    vendorMissingBillHistorySource: VendorMissingBillsHistoryResultDto[] = [];
    vendorMissingBillHistoryColumns: any[] = [];
    vendorMissingBillHistoryTitle: string;

    iconClose = IconConstants.CLOSE;

    loadingVisible = false;

    constructor(
        private readonly vendorMissingBillService: WorkflowVendorMissingBillsService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
        this.setMissingBillHistoryColumns();
        this.setMissingBillHistoryTitle();
        this.getMissingBillHistory();
    }

    onHistoryShown(): void {
        this.visible = true;
        this.vendorMissingBillHistoryPopup.instance.repaint();
    }

    onHistoryClose(): void {
        this.vendorMissingBillHistoryPopup.visible = false;
        this.visible = false;
        this.onClose.emit();
    }

    private setMissingBillHistoryColumns(): void {
        this.vendorMissingBillHistoryColumns = [
            {
                dataField: 'action',
                dataType: 'string',
                caption: 'Action'
            },
            {
                dataField: 'user.displayName',
                dataType: 'string',
                caption: 'User'
            },
            {
                dataField: 'actionedOn',
                dataType: 'date',
                caption: 'Date'
            },
            {
                dataField: 'beginStep',
                dataType: 'string',
                caption: 'Begin Step'
            },
            {
                dataField: 'endStep',
                dataType: 'string',
                caption: 'End Step'
            },
            {
                dataField: 'additionalInfo',
                dataType: 'string',
                caption: 'Additional Info'
            }
        ];
    }

    private setMissingBillHistoryTitle(): void {
        this.vendorMissingBillHistoryTitle = 'Vendor Missing Bill History For # ' + this.missingBillQueueId;
    }

    private getMissingBillHistory(): void {
        const baseParams: VendorMissingBillsHistoryParametersDto = new VendorMissingBillsHistoryParametersDto();
        baseParams.missingBillsQueueId = this.missingBillQueueId;
        baseParams.communityId = this.communityId;

        this.loadingVisible = true;
        this.vendorMissingBillService.getVendorMissingBillHistory(baseParams).subscribe(
            (result: VendorMissingBillsHistoryResultDto[]) => {
                this.vendorMissingBillHistorySource = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
